import React, { Suspense } from 'react'
import { Routes, Route, Outlet, Navigate } from 'react-router-dom'
import FallbackSpinner from './@core/components/spinner'
import UserLayout from './layouts/UserLayout'
import BlankLayout from './@core/layouts/BlankLayout'
import FrequentlyAsked from './views/pages/AffiliateScreenSection/aksedquestions'
// import BlankLayoutWithAppBar from './@core/layouts/BlankLayoutWithAppBar'
const HomePage = React.lazy(() => import('./pages/home'))
const BlogPage = React.lazy(() => import('./pages/blog'))
const BlogDetailPage = React.lazy(() => import('./pages/blog/blogdetail'))
const OurValuePage = React.lazy(() => import('./pages/ourvalue'))
const AffiliateScreen = React.lazy(() => import('./pages/affiliate-screen'))
const KnowledgeBasePage = React.lazy(() => import('./pages/knowledgebase'))
const TermsOfUse = React.lazy(() => import('./pages/termsofused'))
const PrivacyPolicy = React.lazy(() => import('./pages/privacyPolicy'))
const OurPricePage = React.lazy(() => import('./pages/ourprice'))
const OurContactPage = React.lazy(() => import('./pages/ourcontact'))
const ConsultantsPlan = React.lazy(() => import('./pages/ourconsultantsplan'))
const OurPrompt = React.lazy(() => import('./pages/ourprompt'))
const Page401 = React.lazy(() => import('./pages/401'))
const Page404 = React.lazy(() => import('./pages/404'))

function App() {
  return (
    <Suspense fallback={<FallbackSpinner />}>
      <Routes>
        <Route
          element={
            <BlankLayout>
              <Outlet />
            </BlankLayout>
          }
        >
          <Route path='/401' element={<Page401 />} />
          <Route path='/404' element={<Page404 />} />
        </Route>

        <Route
          element={
            <UserLayout>
              <Outlet />
            </UserLayout>
          }
        >
          <Route path='/' element={<HomePage />} />
          {/* <Route path='#our-solution'  />
          <Route path='#how-it-works' /> */}
          <Route path='/blog' element={<BlogPage />} />
          <Route path='/blog/:id' element={<BlogDetailPage />} />
          <Route path='/our-value' element={<OurValuePage />} />
          <Route path='/affiliate-screen' element={<AffiliateScreen />} />
          <Route path='/terms-of-used' element={<TermsOfUse />} />
          <Route path='/our-price' element={<OurPricePage />} />
          <Route path='/our-contact' element={<OurContactPage />} />
          <Route path='/our-consultants' element={<ConsultantsPlan />} />
          <Route path='/our-prompt' element={<OurPrompt />} />
          <Route path='/knowledge-base' element={<KnowledgeBasePage />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/faq' element={<FrequentlyAsked />} />
        </Route>

        <Route path='*' element={<Navigate to='/404' replace />} />
      </Routes>
    </Suspense>
  )
}

export default App
